module.exports = __webpack_public_path__ + "img/IMG_9710-1200w.60368501.jpg";